'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keyMirror = require('react-utils/keyMirror');

var _keyMirror2 = _interopRequireDefault(_keyMirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _keyMirror2.default)({
  ADD_NOTIFICATION: null,
  REMOVE_NOTIFICATION: null
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ReduxMessenger/static-2.1985/js/actions/ActionTypes.js
// module id = 1269
// module chunks = 3